import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enShop from './locales/en/shop.json';
import enCart from './locales/en/cart.json';
import enOrder from './locales/en/order.json';
import enInvoice from './locales/en/invoice.json';
import enInventory from './locales/en/inventory.json';
import enCoupon from './locales/en/coupon.json';
import frCommon from './locales/fr/common.json';
import frHome from './locales/fr/home.json';
import frShop from './locales/fr/shop.json';
import frCart from './locales/fr/cart.json';
import frOrder from './locales/fr/order.json';
import frInvoice from './locales/fr/invoice.json';
import frInventory from './locales/fr/inventory.json';
import frCoupon from './locales/fr/coupon.json';

export const SUPPORTED_LANGUAGES = ['en', 'fr'];

const LOCALE_KEY = 'bwm_locale';

// Safe wrappers: localStorage.getItem/setItem can throw SecurityError in
// storage-blocked contexts (privacy settings, sandboxed origins, etc.).
// Failing silently here is the right trade-off — locale falls back gracefully.
export function getStoredLocale() {
  try {
    return typeof localStorage !== 'undefined'
      ? localStorage.getItem(LOCALE_KEY)
      : null;
  } catch {
    return null;
  }
}

export function setStoredLocale(lng: string) {
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(LOCALE_KEY, lng);
    }
  } catch {
    // storage blocked — locale choice won't persist this session, silent no-op
  }
}

// Resolution chain: localStorage → navigator.language → 'en'
// appConfig.locale is applied reactively in App.jsx after config loads.
export function resolveInitialLocale() {
  const stored = getStoredLocale();
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) return stored;
  if (typeof navigator !== 'undefined') {
    const nav = (navigator.language || '').split('-')[0];
    if (nav && SUPPORTED_LANGUAGES.includes(nav)) return nav;
  }
  return 'en';
}

void i18next
  .use(initReactI18next)
  .init({
    lng: resolveInitialLocale(),
    fallbackLng: 'en',
    ns: ['common', 'home', 'shop', 'cart', 'order', 'invoice', 'inventory', 'coupon'],
    defaultNS: 'common',
    resources: {
      en: {
        common: enCommon,
        home: enHome,
        shop: enShop,
        cart: enCart,
        order: enOrder,
        invoice: enInvoice,
        inventory: enInventory,
        coupon: enCoupon,
      },
      fr: {
        common: frCommon,
        home: frHome,
        shop: frShop,
        cart: frCart,
        order: frOrder,
        invoice: frInvoice,
        inventory: frInventory,
        coupon: frCoupon,
      },
    },
    interpolation: { escapeValue: false },
  });

export default i18next;
